import { CelebrationTooltip } from "@components/adapters/celebration/Tooltip";
import type { TooltipProps } from "@components/contracts/Tooltip.types";

export const Tooltip: React.FC<TooltipProps> = (props) => (
  <CelebrationTooltip {...props} />
);

export type { TooltipProps };
